import React, { useMemo, useEffect, useCallback } from 'react'
import { LockedGrid, Grid as UnlockedGrid, Button, Panel, SegmentedButton, Container } from '@sencha/ext-modern'
import { connect } from 'react-redux'
import _ from 'lodash'

import { fetchManagerData, regenSampleCategoriesData } from './managerUtils'
import { useInstData, useDelayTimer, useEventHandler } from 'tyan/public/hooks'
import Form from '../Form'
import FormMessage from '../FormMessage'
import {
	dataFieldTypes, getColumnType, getDataCols, renderColumn, getModel, tplByColumns, handleItemContextMenu, genContextMenu,
	selectionCheckboxClsField
} from '../column'
import { isAdaptToPhone } from '../..'
import ExportColumns from './ExportColumns'
import Categories from './Categories'
import TopToolbar from './TopToolbar'
import PivotManager from './PivotManager'
import Show from './Show'

const ManagerInnerForm = props => <Form {...props} isManagerInner={true} />
const ManagerInnerFormMessage = props => <FormMessage {...props} isManagerInner={true} />

const genEmptyDataCond = () => ({ searchValue: '', filter: {}, filterChoices: {} })
// 任务相关itemConfig.style 配置
const taskStyleField = '__taskStyle'
const taskStyles = {
	NEW: 'font-weight: bold;color:var(--color)',
	TASK: 'font-weight: unset; color:var(--color)',
	NOTTASK: 'font-weight: unset;color:var(--disabled-color)'
}

taskStyles.Normal = taskStyles.Task

// class Manager extends React.Component {
const ManagerInner = (props) => {
	const {
		config, history, pathname,
		tabs, tabName, tabCounts: tabCountsProp, setTabCounts,
		onInit, component: Comp, compProps = {},
		desktop
	} = props

	const {
		me, setState,
		me: {
			state: {
				list = null, store = null, tabCounts: tabCountsState = null, selectValues = undefined,
				total = null, totalPageNum = null, beginNum = null, endNum = null,
				showDetail: Detail = null, detailProps,
				stampForComp, stampForCategories, sumValues
			},
			isPhone, dataCond, refreshPage,
			grid
		}
	} = useInstData(props, useMemo(() => ({
		state: {
			selected: [],
			checkboxSelected: [],
			stampForCategories: Date.now(),
		},
		isPhone: desktop ? false : Ext.os.is.Phone && isAdaptToPhone(),
		dataCond: genEmptyDataCond(),
		stampForComp: Date.now(),   // 传递给Comp，以通知变化,
		stampForGetManagerData: null,
		showDetail: (showDetail, detailProps = {}) => setState({ showDetail, detailProps }),
		refreshCategories: () => setState({ stampForCategories: Date.now() }),
		refreshPage: () => (me.refreshCategories(), doGetManagerData({ pageNum: me.state.pageNumFetching || me.state.pageNum })),
		closeDetail: () => {
			me.stampForComp = Date.now()
			setState({ showDetail: null, detailProps: null/* , selected: []  */ })
			refreshPage()
		},
		category: null
	}), []))

	const pathMenu = Tyan.menus.allPaths[pathname]
	const needTaskStyle = Tyan.menus.version >= 5 && pathMenu && (pathMenu.taskTabs || []).includes(tabName)
	const tabCounts = tabCountsState || tabCountsProp

	const pageNum = me.state.pageNumFetching || me.state.pageNum || null

	// 检查是否有效数据
	const checkManagerData = useCallback(ids => new Promise(resolve => {
		const stamp = me.stampCheckManagerData = Tyan.getUuid()

		ids = ids || []
		if (!ids.length) {
			console.error('无数据用于检测，请管理员与系统开发商联系!')
			resolve(false)
			return
		}

		// 发起检查交易
		Tyan.sysMode === 'sample'
			? setTimeout(() => resolve(true))
			: Tyan.doPostEvent('CheckManagerData', {
				data: {
					name: pathname.substring(1), tabName, ids,
					roles: Tyan.menus.allPaths[pathname] ? Tyan.menus.allPaths[pathname].roles : [],
					category: me.category
				},
				onEnd: ({ errorMessage, checkResult }) => {
					if (stamp !== me.stampCheckManagerData) {
						resolve(false)
						return
					}
					errorMessage
						? (Ext.toast(errorMessage), resolve(false))
						: (!checkResult && Ext.toast('相关数据不可操作，请刷新数据后重试'), resolve(!!checkResult))
				}
			})
	}), [])

	// 处理自定义工具栏按钮点击事件
	const handleToolbarButton = useCallback(({ checkSelected, handler }) => {
		if (!handler) return

		const { state: { selected } } = me
		const ids = selected.map(o => o.data.id)

		if (checkSelected === true && !ids.length) {
			Ext.toast('请选择需要处理的数据!')
			return
		}

		if (checkSelected === false || !ids.length) {
			handler(me)
			return
		}

		checkManagerData(ids).then(r => r && handler(me))
	}, [])

	const { sampleCategoriesData, sampleData } = useMemo(() => {
		if (!config) throw `${pathname} 无配置信息`

		const { categories, sampleCategoriesData, sampleData } = config
		if (Tyan.sysMode !== 'sample') {
			if (sampleData || sampleCategoriesData) throw `${pathname} 非原型系统 不可配置示例数据`
		} else {
			if (!sampleData) throw `${pathname} 原型系统 未配置示例数据`
			if (categories && !sampleCategoriesData) throw `${pathname} 原型系统 未配置示例分类数据`
		}

		// 解析数据
		return { sampleCategoriesData: regenSampleCategoriesData(sampleCategoriesData), sampleData }
	}, [])

	const columns = config && config.columns
	const sumFields = (config && config.sumFields || []).filter(f => f.field).map(f => ({
		prefix: '合计', suffix: '', rate: 1, decimal: 2, thousand: true, ...f
	}))

	// sumFields: [
	// 	{
	// 		field: 'ContractFees',
	// 		prefix: '合同总金额',
	// 		suffix: '元',
	// 		rate: 1,			// default 1 数据比例, 如0.0001则原始值为10000时，最终值为1
	// 		decimal: 2, 		// default 2 小数位数
	// 		thousand: true,	// default true 使用千分符
	//		displayFn: undefined, 	// default undefined, 回调函数，返回显示用的html片段
	// 	}
	// ],

	const contextmenu = useMemo(() => config && (config.contextmenu || columns && genContextMenu(columns)), [])
	const {/* stopDelay,  */doDelay: delaySelected } = useDelayTimer()
	const { stopDelay: stopDelaySearch, doDelay: delaySearch } = useDelayTimer()

	// did Mount
	useEffect(() => {
		onInit && onInit(me)
		// doGetManagerData()
	}, [])

	// list grid changed, reset selected
	useEffect(() => {
		if (!grid || !list) return
		handleSelectedChanged(grid.gridItems && grid.gridItems[1] || grid)
	}, [grid, list])

	const handleSortersEndUpdate = refreshPage//useEventHandler((...args) => { console.log('Sorters end update:', args) })

	const doGetManagerData = useEventHandler(({ numPerPage = Tyan.psnCfg.numPerPage, pageNum, ...args } = {}) => {
		setState({ pageNumFetching: pageNum })
		const stamp = me.stampForGetManagerData = Date.now()
		// console.log('sumFields:', sumFields.map(o => o.field))
		doFetchManagerData({
			tabName, numPerPage, pageNum, sumFields: sumFields.map(o => o.field), ...args,
			onEnd: () => {
				if (stamp != me.stampForGetManagerData)
					return
				setState({ pageNumFetching: null })
			},
			onSuccess: ({ list, sumValues, total, pageNum, tabCounts, selectValues }) => {
				// console.log('sumValues:', sumValues)
				// 处理list，增加 taskStyleField 字段内容
				if (needTaskStyle) {
					const { [`${pathname}_${tabName || ''}`]: { newIDs = [], allIDs = [] } = {} } = Tyan.menus.tasksMap || {}
					list.forEach(r => r[taskStyleField] = newIDs.includes(r.id) ? taskStyles.NEW : allIDs.includes(r.id) ? taskStyles.TASK : taskStyles.NOTTASK)
				}

				if (stamp != me.stampForGetManagerData)
					return
				const store = me.state.store
				const newStore = list && (store && (store.setData(list), store) || new Ext.data.Store({
					model: getModel({
						checkGridData: checkManagerData,
						multiSelect: calcMe(config.multiSelect),
						columns: config.columns,
					}),
					data: list,
					groupField: config.groupField
				}))
				// store = list && new Ext.data.Store({
				//   model: getModel(config.columns),
				//   data: list,
				// })
				newStore && newStore != store && newStore.getSorters().on({ endupdate: handleSortersEndUpdate, })
				setTabCounts(tabCounts)
				setState({
					list, store: newStore, tabCounts, selectValues,
					total,
					pageNumFetching: null,
					pageNum: pageNum === 0 ? 1 : pageNum,
					totalPageNum: Math.ceil(total / numPerPage) === 0 ? 1 : Math.ceil(total / numPerPage),
					beginNum: numPerPage * (pageNum - 1) + 1,
					endNum: numPerPage * (pageNum - 1) + list.length, sumValues
				})
			}
		})
	})

	// called by doGetManagerData、handleExport、handlePivot、handleShow
	const doFetchManagerData = useEventHandler(
		({ filter, columns, exportColumns, pageNum = 1, numPerPage, onSuccess, onEnd, showFetchSpinner, sourceComponent, ...args } = {}) => {
			columns = columns || config.columns
			const { searchValue: search, filter: filterCond } = dataCond
			filter = filter || filterCond
			let sort = store && store.getSorters().items.reduce((s, v) => (s.push([v.getId(), v.getDirection() == 'ASC']), s), []) || null
			sort && !sort.length && (sort = null)

			// console.log('sort:', sort)
			fetchManagerData(columns, pathname, {
				exportColumns,
				tabName, sampleData, pageNum, numPerPage, search, filter, sort, category: me.category,
				onEnd, onSuccess, sourceComponent,
				showFetchSpinner: showFetchSpinner === undefined ? config.showFetchSpinner : showFetchSpinner,
				onFailure: ({ errorMessage }) => { Ext.toast(errorMessage), console.error(errorMessage) },
				...args
			})
		}
	)

	const handleExport = useCallback(() => {
		const columns = config.exportColumns || config.columns
		const selected = me.state.selected
		const total = me.state.total
		if (total <= 0) return

		stopDelaySearch()

		// 读取列项配置：[{type, desc, name, width, tran}]
		const colsInit = getDataCols(columns, true)
		// colsInit.forEach(o => o.desc = Tyan.t(o.desc, 'columnText'))
		const descs = colsInit.map(o => o.desc)
		const defaults = colsInit.filter(o => o.defaultExport).map(o => o.desc)

		const onExport = (choiced, data) => {
			Tyan.pubForm.mask(Tyan.t('加载中'))

			const cols = colsInit.filter(o => choiced.includes(o.desc))

			// export='selected',use filter
			doFetchManagerData({
				filter: data == 'selected' ? { id: { in: selected.map(o => o.id) } } : undefined,
				columns: config.columns, exportColumns: config.exportColumns, pageNum: 1, numPerPage: 0,
				onSuccess({ list }) {
					closeDialog()
					var exporter = Ext.Factory.exporter({
						type: 'excel',
						fileName: `${config.fileName || config.title || tabName || 'DataExport'}.xlsx`,
						title: config.title/*  || tabName */,
						data: {
							columns: cols.map(c => ({
								text: c.desc, width: c.width, style: { alignment: { horizontal: 'Center' } }
							})),
							groups: [{
								rows: list.map(o => ({
									cells: cols.map(c => ({ value: c.exportTranFn(o[c.name], o) }))
								}))
							}]
						}
					})
					// save the file
					exporter.saveAs().then(() => { exporter.destroy() })
				},
				onEnd: () => setTimeout(Tyan.pubForm.mask, 300)
			})
		}
		const selectedCount = config.multiSelect ? selected.length : 0
		const { closeDialog } = Tyan.pubForm.showDialog(`导出 ${config.title || tabName || ''}`, ExportColumns, { defaults, descs, selected: selectedCount, total, onExport })
	}, [])

	const handlePivot = () => {
		const total = me.state.total
		if (total <= 0) return

		stopDelaySearch()

		const onGetData = (columns, setData) => {
			// console.log('columns:', columns)
			doFetchManagerData({
				columns: config.columns, exportColumns: columns, pageNum: 1, numPerPage: 0,
				onEnd: ({ list, errorMessage }) => {
					// console.log('getData:', list, errorMessage)
					errorMessage ? (Ext.toast(errorMessage), me.closeDetail()) : setData(list)
				}
			})
		}
		me.showDetail(PivotManager, { config, onGetData })
	}

	const handleShow = () => {
		const total = me.state.total
		if (total <= 0) return

		stopDelaySearch()

		me.showDetail(Show, { config, doFetchManagerData })
	}


	const handlePageSelected = useCallback((page, sourceComponent) => { doGetManagerData({ pageNum: page, sourceComponent }) }, [])
	const handleChgNumPerPage = useCallback(numPerPage => { Tyan.setPsnCfg({ numPerPage }), doGetManagerData({ pageNum: me.state.pageNumFetching || me.state.pageNum }) }, [])
	const handleSearchFieldChange = useEventHandler(useCallback((obj, newValue) => { dataCond.searchValue = newValue; delaySearch(doGetManagerData) }, [dataCond]))
	const handleSelectedChanged = useCallback(obj => {
		const newSelected = [...obj.getSelected().items]
		const newCheckboxSelected = newSelected.filter(({ data: { [selectionCheckboxClsField]: v } }) => !v)
		delaySelected(() => setState({ selected: newSelected, checkboxSelected: newCheckboxSelected }),
			!_.isEqual(me.state.selected, newSelected) || !_.isEqual(me.state.checkboxSelected, newCheckboxSelected),
			10)
	}, [])
	const handleSelect = useCallback((...args) => {
		// console.log('select:', args[1].$cloned)
		args[1].$cloned || handleSelectedChanged(...args)
	}, [])
	const handleDeselect = useCallback((...args) => {
		handleSelectedChanged(...args)
	}, [])

	const handleTabChange = useCallback((obj, newTabName) => {
		if (tabName == newTabName)
			return

		setTimeout(() => history.push(`${pathname}${newTabName ? `?${encodeURIComponent(newTabName)}` : ''}`))
	}, [])

	// const handleColumnSort = refreshPage  // (/* grid, column, direction, ...args */) => 
	// const handleStoreChange = useCallback((grid, store) => { grid && store && handleSelectedChanged(grid) }, [])
	const handleFilterChange = (/* filterProp */) => delaySearch(doGetManagerData)
	const handleChildDoubleTap = useCallback((grid, location) => {
		if (location.recordIndex < 0)
			return

		const { record: { data } = {}, record } = location || {}
		const { onDoubleTap, onDoubleTap2 } = config || {}
		record && (onDoubleTap2 || onDoubleTap) && checkManagerData([data.id]).then(r => {
			r && (
				onDoubleTap2
					? onDoubleTap2({ data, record, grid, that: me, location })
					: onDoubleTap(me, data, record, grid, location)
			)
		})
	}, [config])

	const handleChildTap = useCallback((...args) => {
		const [grid, { cell: { xtype } = {}, actionable }] = args
		// console.log('actionable:', Ext.platformTags.touch, actionable, args[1])
		Ext.platformTags.touch && !actionable/* xtype !== 'checkcell' */ && handleChildDoubleTap(...args)
	}, [config])

	const calcMe = useCallback(p => typeof p == 'function' ? p(me) : p, [])

	const handleCategoryChange = useCallback(category => {
		const keepPage = _.isEqual(category, me.category)
		me.category = category
		doGetManagerData(keepPage ? { pageNum: me.state.pageNumFetching || me.state.pageNum } : undefined)
	}, [])

	const { Grid, gridProps } = useMemo(() => {
		const listeners = {
			select: handleSelect,
			deselect: handleDeselect,
			// columnSort: handleColumnSort,
			// storeChange: handleStoreChange,
			// childTap: handleChildTap,
			childDoubleTap: handleChildDoubleTap
		}
		contextmenu && (listeners.childContextMenu = listeners.childLongPress = (grid, { record, event }) => {
			handleItemContextMenu(contextmenu, grid, record, event, me, checkManagerData)
		})

		const multiSelect = calcMe(config.multiSelect)
		const Grid = Ext.os.is.Phone ? UnlockedGrid : LockedGrid

		const gridDefaults = {
			itemConfig: {
				viewModel: {}, /* height: '40px', */
				bind: {
					userCls: `{record.${selectionCheckboxClsField}}`,
					...(needTaskStyle && { style: `{record.${taskStyleField}}` } || {})
				}
			},
			listeners,
		}

		Ext.merge(
			gridDefaults,
			isPhone
				? { hideHeaders: true, itemConfig: { body: { tpl: tplByColumns(columns) } } }
				: { itemConfig: { height: '40px' } }
		)

		!isPhone && multiSelect && (gridDefaults.selectable = { /* extensible: "both",  */rows: true, cells: false, columns: false/* , drag: true  */ })
		const gridProps = (Grid == 'LockedGrid') ? {
			gridDefaults, ...(multiSelect ? { leftRegionDefaults: { locked: true, grid: { selectable: { checkbox: true } } } } : {})
		} : Ext.merge(gridDefaults, multiSelect ? { selectable: { checkbox: true } } : {})
		return { Grid, gridProps }
	}, [isPhone, columns, Ext.os.is.Phone, config])

	const { searchValue } = dataCond
	const columnConfig = useMemo(() => {
		const { filter: filterProp, filterChoices } = dataCond
		return { filterProp, filterChoices, onFilterChange: handleFilterChange, selectValues }
	}, [dataCond, selectValues])

	// const refGrid = useRef()
	// console.log('debug Manager render')
	const emptyStore = useMemo(() => new Ext.data.Store({ data: [] }))

	const renderInnerDetail = useCallback(() => {
		const { innerDetail } = config || {}
		const { component: Comp, compProps = {}, containerProps: panelProps = {} } = typeof innerDetail === 'function' ? innerDetail(me) : (innerDetail || {})
		if (!Comp) return null

		return <Panel margin='0 10 10 10' shadow layout='fit' docked='bottom' height='40%' bodyPadding='5' resizable={{ /* split: true, */ edges: 'north', dynamic: true }} {...panelProps}>
			<Comp {...compProps} selectedRecords={me.state.selected} that={me} showBody={ManagerInnerForm} showMessage={ManagerInnerFormMessage} />
		</Panel>
	}, [config])

	// console.log('render selected:', me.state.selected, me.state.checkboxSelected)

	return <>
		<Container layout='fit' scrollable hidden={!Detail}>
			{Detail && <Detail {...detailProps} showBody={Form} showMessage={FormMessage} onClose={me.closeDetail} />}
		</Container>
		<Container defaults={{ /* autosize: true,  */flex: 1 }} hidden={!!Detail} width={!isPhone && 700}
			layout={{ type: 'vbox', pack: 'center', align: 'stretch' }}
		>
			{Comp && <Container
				defaults={{ flex: 1, bodyPadding: 10, shadow: true, margin: "5 10 5 10" }}
				layout={{ type: isPhone ? 'vbox' : 'hbox', pack: 'center', align: 'stretch' }}
			>
				<Comp stamp={stampForComp} {...compProps} />
			</Container> || null}
			<Container
				defaults={{ flex: 1, /* bodyPadding: 10,  */shadow: true, margin: 10 }}
				layout={{ type: isPhone ? 'vbox' : 'hbox', pack: 'center', align: 'stretch' }}
			>
				<TopToolbar {...{
					calcThat: calcMe, isPhone,
					config, columnConfig, tabs, searchValue, handleSearchFieldChange, tabName, handleTabChange: handleTabChange, tabCounts,
					handleExport, handlePivot, handleShow,
					total, list, beginNum, endNum, pageNum, totalPageNum, onPageSelected: handlePageSelected, onChgNumPerPage: handleChgNumPerPage,
					handleToolbarButton,
					sumFields, sumValues
				}} />
				<Categories key={`categories${tabName}`} {...{
					stamp: stampForCategories, pathname, tabName, config: config.categories, sampleCategoriesData, onChange: handleCategoryChange,
					that: me, showFetchSpinner: config.showFetchSpinner
				}} />
				{/* {!store ? <FormMessage text={'加载中 ...'} /> : null} */}
				{/* {store && */}
				<Container key={`grid${tabName}`} layout='fit' shadow={false} margin='0'>
					<Panel key={`grid${tabName}`} layout='fit' margin={config.categories ? "5 10 10 10" : "5 10 10 10"} shadow >
						<Grid
							ref={ref => /* window.grid =  */me.grid = ref && ref.cmp || null}
							userCls='t_manager'
							store={store || emptyStore} scrollable {...gridProps}
						>
							{
								config.columns.filter((c, i) => !isPhone || i === 0 || (c.phone != false && !dataFieldTypes.includes(getColumnType(c)))).map((column, key) =>
									renderColumn({ ...column, ...columnConfig }, key, me, undefined, checkManagerData)
								)
							}
						</Grid>
						{
							isPhone && tabs && Object.keys(tabs).length &&
							<SegmentedButton defaultUI="toolbar-default" value={tabName} onChange={handleTabChange} margin="5 10 0 0" maxHeight="38px" docked='bottom'>
								{Object.keys(tabs).map(tn => <Button key={tn} value={tn} text={tn + (tabCounts && tabCounts[tn] && `(${tabCounts[tn]})` || '')} />)}
							</SegmentedButton> || null
						}
					</Panel>
					{renderInnerDetail()}
				</Container>
			</Container>
		</Container>
	</>
}

const mapStateToProps = ({ loginInfo: { roles } }) => ({ roles, })

// export default Manager
export default connect(mapStateToProps)(ManagerInner)